import { css } from '@emotion/css';

const wrapper = css`
  padding: var(--spacings-3) !important;
`;

const title = css`
  text-align: center;
  margin-bottom: var(--spacings-5) !important;
`;

const alertContainer = css({
  marginBottom: 'var(--spacings-6)',
});

const alert = css({
  border: '1px solid var(--colors-warning-950)',
  '&.MuiPaper-root.MuiAlert-root': {
    borderRadius: 'var(--radius-2)',
  },
  '& .MuiAlert-message': {
    color: 'var(--colors-warning-950)',
  },
  '& .MuiAlert-icon': {
    fontSize: '1rem',
  },
});

const AddFundsModalStyles = {
  wrapper,
  title,
  alertContainer,
  alert,
};

export default AddFundsModalStyles;
